const doc = [({"da":({"js":({"merfoto":({"users":({"passwords":({"new":({"forgot_your_password":"Glemt din adgangskode?"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;